export { matchers } from './client-matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27')
];

export const dictionary = {
	"": [[1], [0], 7],
	"client": [[1], [0,3], 12],
	"contact": [[1], [0], 16],
	"product": [[1], [0], 24],
	"auth/layout-old": [[1], [0,2], 8],
	"auth/login": [[1], [0,2], 9],
	"auth/register": [[1], [0,2], 10],
	"auth/resetpwd": [[1], [0,2], 11],
	"client/center": [[1], [0,3], 13],
	"client/inquire": [[1], [0,3], 14],
	"client/product": [[1], [0,3], 15],
	"dynamic/notice": [[1], [0,4], 18],
	"info/about": [[1], [0,5], 19],
	"info/culture": [[1], [0,5], 20],
	"info/honor": [[1], [0,5], 21],
	"info/speech": [[1], [0,5], 22],
	"info/team": [[1], [0,5], 23],
	"research/angle": [[1], [0,6], 25],
	"research/report": [[1], [0,6], 26],
	"research/teach": [[1], [0,6], 27],
	"detail/[...data]": [[1], [0], 17]
};